export default {
    alexa: {
        tcl_assitant: "Enable Skill - TCL Assistant",
        active_code_hint: "確認コードを入力してください",
        active_code_placeholder: "Activation Code",

        active_code_message: "あなたのTclテレビで、設定を押してください",
        active_code_message_path: " あなたのリモート上のボタン、'システム'>' Alexa 'で動作します。",
        active_code_message_part2: "活性化コードを取得するには'サインイン'または'取得コード'を選択します。",

        active_code_message_old: "TCL TVで移動する",
        active_code_message_path_old: "設定/システム/ Amazon Alexa /コードの取得, ",
        active_code_message_part2_old: "以下にアクティベーションコードを入力する.",

        active_code_error_null: "コードを無効な値にすることはできません",
        active_code_error_number: "番号を入力してください",
        active_code_error_bits: "コードは6つのデジタル番号にしてください",
        active_code_validate: "有効にする",
        active_code_message_wrong: "アクティベーションコードが正しくないか期限切れです。再取得してください。.",
        active_code_message_exception: "ネットワークを確認してもう一度やり直してください.",
        check_agreements_message: "TCL Assistantを使用するには、すべての契約に同意する必要があります.",
        agreements: [
            "I agree TCL to record my voice command",
            "TCLの",
            "に同意します.",
        ],
        privacy_policy: "プライバシーポリシー",

        grant_hint: "TCLはあなたに代わってアクションを実行します",
        grant_message_success: "権限が正常に付与されました!",
        grant_message_fail: "失敗しました。アクティブなコードを再入力してください",
        grant_allow: "許可する",

        console_welcome_prompt: "Welcome to TCL Alexa Console",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/jp.js
// module id = null
// module chunks = 